<template>
  <v-dialog v-model="show" max-width="900" persistent>
    <v-card>
      <v-card-title class="grey lighten-3">
        <v-row>
          <v-icon class="draggable">mdi-drag</v-icon>
          <v-col class="py-0">Edit Discount</v-col>
        </v-row>
      </v-card-title>
      <v-card-text class="pb-0">
        <v-row>
          <v-col>
            <date-range-picker
              :gt-date-from-string="validFrom"
              :gt-date-to-string="validTo"
              @onRangeSelected="onDateRangeSelected"
              :outlined="outlinedInputs"
            ></date-range-picker>
          </v-col>
          <v-col sm="3">
            <date-picker
              custom-label="Book Before"
              v-model="bookBeforeDate"
              :outlined="outlinedInputs"
            ></date-picker>
          </v-col>
          <v-col sm="2">
            <v-text-field
              type="number"
              label="Advance Days"
              v-model="advanceDays"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col v-if="false">
            <v-switch v-model="round" label="Use Rounding"></v-switch>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <agent-group-select
              v-model="agentGroup"
              :outlined="outlinedInputs"
              :groupsOnly="true"
            ></agent-group-select>
          </v-col>

          <v-col>
            <v-text-field
              type="number"
              label="Book (Min Duration)"
              v-model="minBook"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              type="number"
              label="Free"
              v-model="free"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              type="number"
              label="Discount %"
              v-model="percent"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row>
          <v-col>
            <v-text-field
              type="text"
              label="Description"
              v-model="description"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-col>
          <v-col v-if="false">
            <v-select
              label="Services"
              :items="services"
              v-model="selectedService"
              item-text="node.name"
              item-value="node.id"
              :outlined="outlinedInputs"
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-alert text type="info" dense outlined>
              Editing this discount will apply the update to all services on
              this discount group.
            </v-alert>
          </v-col>
        </v-row>
        <v-row v-if="debug">
          <v-col>
            <code
              >{{ value }} --- {{ selectedService }} --
              {{ bookBeforeDate }}</code
            >
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="grey lighten-4">
        <div class="flex-grow-1"></div>
        <v-btn color="warning" text @click="$emit('close')">Cancel</v-btn>
        <v-btn color="primary" @click="onSave">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import DateRangePicker from "../../shared/DatesRangePicker.vue";
import DatePicker from "../../shared/DatePicker.vue";
import AgentGroupSelect from "../../shared/AgentGroupSelect";
export default {
  name: "discount-item-editor",

  props: {
    value: {
      type: Object,
      default: () => null,
    },
    show: {
      type: Boolean,
      default: () => false,
    },
    services: {
      type: Array,
      default: () => [],
    },
  },

  components: {
    DateRangePicker,
    DatePicker,
    AgentGroupSelect,
  },

  data() {
    return {
      debug: false,
      minBook: this.value && this.value.minBook ? this.value.minBook : 0,
      free: this.value && this.value.free ? this.value.free : 0,
      percent: this.value && this.value.percent ? this.value.percent : 0,
      validFrom: this.value && this.value.validFrom ? this.value.validFrom : "",
      validTo: this.value && this.value.validTo ? this.value.validTo : "",
      bookBeforeDate:
        this.value && this.value.bookBeforeDate
          ? this.value.bookBeforeDate
          : "",
      advanceDays:
        this.value && this.value.advanceDays ? this.value.advanceDays : 0,
      round:
        this.value && this.value.round
          ? this.value.round.toString() == "true"
          : false,
      selectedService:
        this.value && this.value.service ? this.value.service.id : null,
      description:
        this.value && this.value.description ? this.value.description : "",
      agentGroup: this.value && this.value.groupId ? this.value.groupId : "",
    };
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
  },

  watch: {
    value(newVal) {
      if (newVal) {
        this.minBook = newVal.minBook;
        this.free = newVal.free;
        this.percent = newVal.percent;
        this.round = newVal.round ? newVal.round.toString() == "true" : false;
        this.validFrom = newVal.validFrom;
        this.validTo = newVal.validTo;
        this.bookBeforeDate = newVal.bookBeforeDate;
        this.advanceDays = newVal.advanceDays;
        this.selectedService = newVal.service ? newVal.service.id : null;
        this.agentGroup = newVal.groupId;
        this.description = newVal.description;
      }
    },
  },
  methods: {
    onDateRangeSelected({ dateFrom, dateTo }) {
      this.validFrom = dateFrom;
      this.validTo = dateTo;
    },
    onSave() {
      this.$emit("input", {
        ...this.value,
        minBook: this.minBook,
        free: this.free,
        percent: this.percent,
        round: this.round,
        validFrom: this.validFrom,
        validTo: this.validTo,
        bookBeforeDate: this.bookBeforeDate,
        advanceDays: this.advanceDays,
        description: this.description,
        //serviceId: this.selectedService,
        groupId: this.agentGroup,
      });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/suppliers/discounts/DiscountItemEditor.vue